import type { CountryMessage } from '../../../../types/CountryMessage';
import { PaginatedAsyncComboBox } from '../../../cdl/ComboBox/ComboBox';
import { getCountries } from '../../../common/api/clients/coreData.api';
import { queries } from '../../../common/api/queryKeys/queries';
import { translate } from '../../../common/helpers/translate.helper';

export interface CountrySelectState {
    label: string;
    value: string;
    country: CountryMessage;
}

interface CountrySelectProps {
    countryId?: string;
    onChange?: (value: CountrySelectState) => void;
}

export function CountrySelect({ countryId, onChange, ...props }: CountrySelectProps) {
    const loadCountriesBySearchQuery = async (searchQuery: string, page: number) => {
        const countriesPage = await getCountries(searchQuery, page);

        return {
            ...countriesPage,
            content: countriesPage.content.map((country) => ({
                label: country.name,
                value: country.id,
                country,
            })),
        };
    };

    const loadCountryById = (countryId: string): Promise<CountrySelectState> => {
        return getCountries(countryId).then((response) => {
            const country = response.content[0];
            return {
                label: country.name,
                value: country.id,
                country,
            };
        });
    };

    return (
        <PaginatedAsyncComboBox<CountrySelectState>
            {...props}
            placeholder={translate('countrySelect.placeholder')}
            value={countryId ?? null}
            onChange={(_, meta) => {
                if (meta.option) {
                    onChange?.(meta.option);
                }
            }}
            optionsQueryKey={(search) => queries.countries.comboBoxOptions(search).queryKey}
            optionsQueryFn={({ search, page }) => loadCountriesBySearchQuery(search, page)}
            selectedOptionQueryKey={(id) => queries.countries.selectedComboBoxOption(id).queryKey}
            selectedOptionQueryFn={loadCountryById}
        />
    );
}
